// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k1RJgokp32g9H7kkmVvM {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 0;
  border: 0;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
}

.kfuZFqsQ5QlIRr3u1FMe {
  opacity: 0.45;
  cursor: not-allowed;
}

.Zu1PuWL_5rUDW7jNsBQW {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.lBV6_vwMq9z5MMJ2E08h {
  position: relative;
  width: 28px;
  height: 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.28);
  transition: background 0.15s ease, border-color 0.15s ease;
}

.Zkr1RpaRpX8uoFVjkWja {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fbfcf6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  transition: transform 0.15s ease;
}

.gwj7RFOp6fm9YwReiZle .lBV6_vwMq9z5MMJ2E08h {
  background: rgba(251, 170, 105, 0.35);
  border-color: rgba(251, 170, 105, 0.65);
}

.gwj7RFOp6fm9YwReiZle .Zkr1RpaRpX8uoFVjkWja {
  transform: translateX(12px);
}

.PudKgA0jorqK_zlUaqm6 {
  font-size: 11px;
  color: rgba(251, 252, 246, 0.75);
  line-height: 1;
}

.gwj7RFOp6fm9YwReiZle .PudKgA0jorqK_zlUaqm6 {
  color: rgb(251, 170, 105);
}

.kDMvBKrS_ZG3NPeCy2MP {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(251, 252, 246, 0.65);
  line-height: 1;
}

.gwj7RFOp6fm9YwReiZle .kDMvBKrS_ZG3NPeCy2MP {
  color: rgba(251, 252, 246, 0.92);
}

/* Built-in tools rail (dark chrome) */
.HXIVH7fS6FDgpNrbg2yd.gwj7RFOp6fm9YwReiZle .lBV6_vwMq9z5MMJ2E08h {
  background: rgba(251, 170, 105, 0.28);
}

.HXIVH7fS6FDgpNrbg2yd .kDMvBKrS_ZG3NPeCy2MP {
  font-size: 8px;
}

/* Node footer sits on light canvas — invert chrome */
.Xxi3O6yjh3txSZ5ZI7hQ .lBV6_vwMq9z5MMJ2E08h {
  background: #e8e6e0;
  border-color: #c8c6c0;
}

.Xxi3O6yjh3txSZ5ZI7hQ .Zkr1RpaRpX8uoFVjkWja {
  background: #fff;
}

.Xxi3O6yjh3txSZ5ZI7hQ .PudKgA0jorqK_zlUaqm6 {
  color: #6b6c70;
}

.Xxi3O6yjh3txSZ5ZI7hQ .kDMvBKrS_ZG3NPeCy2MP {
  color: #6b6c70;
}

.Xxi3O6yjh3txSZ5ZI7hQ.gwj7RFOp6fm9YwReiZle .lBV6_vwMq9z5MMJ2E08h {
  background: rgba(251, 170, 105, 0.45);
  border-color: rgb(251, 170, 105);
}

.Xxi3O6yjh3txSZ5ZI7hQ.gwj7RFOp6fm9YwReiZle .PudKgA0jorqK_zlUaqm6,
.Xxi3O6yjh3txSZ5ZI7hQ.gwj7RFOp6fm9YwReiZle .kDMvBKrS_ZG3NPeCy2MP {
  color: #c45f12;
}
`, "",{"version":3,"sources":["webpack://./src/components/nodes/SaveOutputToggle.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,2CAA2C;EAC3C,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".root {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  cursor: pointer;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.rootDisabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.track {\n  position: relative;\n  width: 28px;\n  height: 16px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.thumb {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #fbfcf6;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n  transition: transform 0.15s ease;\n}\n\n.rootOn .track {\n  background: rgba(251, 170, 105, 0.35);\n  border-color: rgba(251, 170, 105, 0.65);\n}\n\n.rootOn .thumb {\n  transform: translateX(12px);\n}\n\n.icon {\n  font-size: 11px;\n  color: rgba(251, 252, 246, 0.75);\n  line-height: 1;\n}\n\n.rootOn .icon {\n  color: rgb(251, 170, 105);\n}\n\n.label {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: rgba(251, 252, 246, 0.65);\n  line-height: 1;\n}\n\n.rootOn .label {\n  color: rgba(251, 252, 246, 0.92);\n}\n\n/* Built-in tools rail (dark chrome) */\n.toolbar.rootOn .track {\n  background: rgba(251, 170, 105, 0.28);\n}\n\n.toolbar .label {\n  font-size: 8px;\n}\n\n/* Node footer sits on light canvas — invert chrome */\n.node .track {\n  background: #e8e6e0;\n  border-color: #c8c6c0;\n}\n\n.node .thumb {\n  background: #fff;\n}\n\n.node .icon {\n  color: #6b6c70;\n}\n\n.node .label {\n  color: #6b6c70;\n}\n\n.node.rootOn .track {\n  background: rgba(251, 170, 105, 0.45);\n  border-color: rgb(251, 170, 105);\n}\n\n.node.rootOn .icon,\n.node.rootOn .label {\n  color: #c45f12;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `k1RJgokp32g9H7kkmVvM`,
	"rootDisabled": `kfuZFqsQ5QlIRr3u1FMe`,
	"input": `Zu1PuWL_5rUDW7jNsBQW`,
	"track": `lBV6_vwMq9z5MMJ2E08h`,
	"thumb": `Zkr1RpaRpX8uoFVjkWja`,
	"rootOn": `gwj7RFOp6fm9YwReiZle`,
	"icon": `PudKgA0jorqK_zlUaqm6`,
	"label": `kDMvBKrS_ZG3NPeCy2MP`,
	"toolbar": `HXIVH7fS6FDgpNrbg2yd`,
	"node": `Xxi3O6yjh3txSZ5ZI7hQ`
};
export default ___CSS_LOADER_EXPORT___;
